import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import NewsletterCTA from '../components/NewsletterCTA';
import LatestVideos from '../components/LatestVideos';
import { heroImages } from '../utils/heroImages';

const HomePage: React.FC = () => {
  useEffect(() => {
    document.title = 'CryptoIndia - India\'s Premier Crypto Destination';
  }, []);

  return (
    <div>
      <Hero 
        title="India's Premier Crypto Destination"
        subtitle="Join millions of traders, investors & learners. Deep-dive videos, real-time updates and exclusive insights—on YouTube, X and beyond."
        ctaText={
          <div className="flex flex-col sm:flex-row gap-4">
            <a 
              href="https://www.youtube.com/@cryptoindia"
              target="_blank"
              rel="noopener noreferrer"
              className="btn bg-red-500 hover:bg-red-600 text-white group"
            >
              Subscribe on YouTube 
              <span className="ml-2 group-hover:translate-x-1 transition-transform">→</span>
            </a>
            <a 
              href="https://t.me/OfficiaLCryptoindia"
              target="_blank"
              rel="noopener noreferrer"
              className="btn bg-blue-500 hover:bg-blue-600 text-white group"
            >
              Join Telegram 
              <span className="ml-2 group-hover:translate-x-1 transition-transform">→</span>
            </a>
            <a 
              href="https://x.com/CryptooIndia"
              target="_blank"
              rel="noopener noreferrer"
              className="btn border-2 border-yellow-400 text-yellow-400 hover:bg-yellow-400 hover:text-black group"
            >
              Follow on X 
              <span className="ml-2 group-hover:translate-x-1 transition-transform">→</span>
            </a>
          </div>
        }
        config={heroImages.home}
      />
      
      <LatestVideos />

      <NewsletterCTA />
    </div>
  );
};

export default HomePage;